<template>
  <v-container>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-card
          class="ml-5"
          width="550"
          height="430"
          v-for="(item, index) in cardProAccount1"
          :key="index"
        >
          <v-card-text>
            <p class="text-subtitle-1 primary--text mt-2 mb-1">
              {{ item.subtitle }}
            </p>
            <v-divider inset class="ml-0 mb-5" width="90%"></v-divider>
          </v-card-text>
          <v-form>
            <v-form-base
              :schema="schemaForm"
              :model="modelForm"
              @input="handleEvents"
              class="d-flex mx-xs-10 mx-sm-10"
            />
            <v-row class="d-flex justify-star mx-5">
              <v-col cols="6" xs="6" sm="4" class="d-flex mt-2 justify-center text-caption">
                <v-dialog-pin :dialogPin="dialogAccountPin" />
              </v-col>
              <v-col cols="6" xs="6" sm="4" class="d-flex mt-2 justify-center text-caption">
                <v-dialog-account-pass
                  :dialogAccountPass="dialogAccountPass"
                  :schemaForm="schemaFormPass"
                />
              </v-col>
              <v-col cols="6" xs="6" sm="4" class="d-flex mt-2 justify-center text-caption">
                <v-dialog-account-del :dialogAccountDel="dialogAccountDel" />
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VFormBase from 'vuetify-form-base';
import VDialogPin from '@/components/base/VDialogPin.vue';
import VDialogAccountPass from '@/components/base/VDialogAccountPass.vue';
import VDialogAccountDel from '@/components/base/VDialogAccountDel.vue';

export default {
  name: 'VCardProAccountForm',
  components: {
    VFormBase,
    VDialogPin,
    VDialogAccountPass,
    VDialogAccountDel,
  },
  props: [
    'schemaForm',
    'modelForm',
    'cardProAccount1',
    'dialogAccountPin',
    'dialogAccountPass',
    'schemaFormPass',
    'dialogAccountDel',
  ],
  data() {
    return {
      switch1: false,
    };
  },
  methods: {
    handleEvents() {},
  },
};
</script>

<style scoped>
.v-text-field--outlined fieldset {
  font-size: 90px;
}
</style>
